var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormula(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 10",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 .5a.5.5 0 01-.5.5H8.056L5.213 9.42a.5.5 0 01-.474.34h-.002a.5.5 0 01-.473-.344l-1.69-5.19L.8 5.555a.5.5 0 11-.6-.8l2.334-1.75a.498.498 0 01.775.245l1.44 4.42L7.222.34A.5.5 0 017.697 0H15.5a.5.5 0 01.5.5zm-2.072 3.04a.5.5 0 00-.707 0l-1.668 1.67-1.67-1.67a.5.5 0 10-.706.708l1.669 1.668-1.67 1.669a.5.5 0 10.708.707l1.669-1.669 1.668 1.669a.499.499 0 10.707-.707L12.26 5.916l1.668-1.668a.5.5 0 000-.707z"
  })));
}
export default SvgFormula;